<template>
  <q-expansion-item
    v-model="isOpen"
    class="card-item q-mb-md bg-white"
  >
    <template #header>
      <q-item-section
        avatar
        class="col-auto items-center q-pr-md"
      >
        <component
          v-if="!isEmail"
          :is="attendanceIcon"
        />
        <q-icon
          v-else
          :name="`${attendance.direction === 'OUT' ? 'mdi-email-receive-outline' : 'mdi-email-send-outline'}`"
          size="sm"
          color="primary"
        />
      </q-item-section>

      <q-separator />

      <q-item-section>
        <q-item-label
          class="item-subtitle"
        >
          <span style="font-size: 0.95em">{{ dateFormated(attendance) }}</span> - Agente: <strong>{{ agentName }}</strong>
        </q-item-label>

        <q-item-section class="item-subtitle">
          <span :class="{ 'no-select': isAnonymizationEnabled }">
            Contato: <strong>{{ displayPhone }}</strong>
            <q-tooltip v-if="isAnonymizationEnabled">
              Número anonimizado por política de segurança
            </q-tooltip>
          </span>
        </q-item-section>

        <q-item-label class="item-subtitle">
          Fila: <strong>{{ attendance.queueName }}</strong> / Canal: <strong>{{ attendance.type }}-{{ attendance.directionName }}</strong>
        </q-item-label>

        <q-item-label caption>
          Situação: <strong>{{ attendance.status == 'ERROR' ? 'Falha' : attendance.status }}</strong> / Perfilamento: <strong>{{ hasProfiler ? 'Sim' : 'Não' }}</strong>
        </q-item-label>
      </q-item-section>

      <q-item-section
        side
        top
      >
        <div class="column justift-center full-height">
          <q-badge
            v-if="attendance.incidenceType"
            outline
            align="middle"
            class="col"
            :color="incidenceColor[attendance.incidenceType]"
          >
            {{ attendance.incidenceType }}
          </q-badge>
        </div>
      </q-item-section>
    </template>

    <q-separator />

    <ContactHistoryItemDetails
      v-if="isOpen"
      :attendance="attendance"
    />
  </q-expansion-item>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import MessageOutIcon from '@/assets/icons/messageOut.svg'
import MessageInIcon from '@/assets/icons/messageIn.svg'
import IconCallAnsweredOut from '@/assets/icons/call-answered-out.svg'
import IconCallAnsweredIn from '@/assets/icons/call-answered-in.svg'
import ContactHistoryItemDetails from './ContactHistoryItemDetails.vue'
import { anonymizePhone } from '@/components/utils/phones'

const incidenceColor = {
  Rechamada: 'red',
  Reincidente: 'purple',
  Recorrente: 'orange'
}

export default {
  components: {
    MessageOutIcon,
    ContactHistoryItemDetails
  },

  props: {
    attendance: {}
  },

  data () {
    return {
      isOpen: false,
      loading: false,
      history: {},
      incidenceColor
    }
  },

  computed: {
    ...mapGetters({
      queueProperties: 'agentModule/queueProperties'
    }),

    isText () {
      return this.attendance.type === 'Texto'
    },

    isEmail () {
      return this.attendance.type === 'Email'
    },

    isIn () {
      return this.attendance.direction === 'IN'
    },

    attendanceIcon () {
      const vm = this
      if (vm.isText) return vm.isIn ? MessageInIcon : MessageOutIcon
      return vm.isIn ? IconCallAnsweredIn : IconCallAnsweredOut
    },

    agentName () {
      return this.attendance.agentName ?? '-'
    },

    hasProfiler () {
      const vm = this
      const tree = vm.attendance.tree
      const profilers = vm.attendance.profilers
      return Boolean(tree) || Boolean(profilers && Object.keys(profilers).length)
    },

    displayPhone () {
      const queueProps = this.queueProperties(this.attendance.queueId)
      const shouldAnonymize = queueProps?.anonymizePhone === 'yes'
      if (shouldAnonymize) {
        return anonymizePhone(this.attendance.contactNumber)
      }

      return this.attendance.contactNumber
    },

    isAnonymizationEnabled () {
      const queueProps = this.queueProperties(this.attendance.queueId)
      return queueProps?.anonymizePhone === 'yes'
    }
  },

  methods: {
    dateFormated (attendance) {
      return moment.unix(attendance.createdAt).format('DD/MM/YY HH:mm')
    }
  }
}

</script>

<style lang="sass" scoped>
  .item-subtitle
    font-size: 13px

  .no-select
    user-select: none
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
</style>
